<template>
  <div>
    <img src="@/assets/images/Billing TIE logo.png" />
    <img class="right-logo" src="@/assets/images/Billing Tamai logo.png" />

    <label :class="showCurrentDate ? 'billing-title-with-date' : 'billing-title'">
      KIWAMI AAA+ ID使用料 御請求書
    </label>

    <div class="float-right billing-date" v-if="showCurrentDate">発行日：{{ exportDateDisplay }}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    showCurrentDate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    exportDateDisplay() {
      if (this.exportDate) {
        return `${this.exportDate.year}年${this.exportDate.month}月${this.exportDate.day}日`;
      }
      return '―';
    },
    ...mapState({
      exportDate: (state) => state.billing.exportDate,
    }),
  },
};
</script>

<style scoped>
.right-logo {
  margin-left: 5px;
}
.billing-title {
  font-size: 25px;
  text-align: center;
  width: 80%;
}
.billing-title-with-date {
  font-size: 20px;
  text-align: center;
  width: 65%;
}
.billing-date {
  margin-right: 10px;
}
</style>
